import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';
import { IOrderTargetMargin, ITargetMarginOriginalResponse } from './Order.redux';

export interface IOrderRateElement {
  offContractId: null | string;
  rateElementId: string;
  effectiveStartDate: Date;
  effectiveEndDate: Date;
  rateElementNameId: number;
  rateElementName: string;
  disciplineId: number;
  disciplineName: null | string;
  disciplineAbbreviation: null | string;
  specialtyId: number;
  specialtyName: null | string;
  specialtyAbbreviation: null;
  subSpecialtyId: number;
  subSpecialtyName: null | string;
  subSpecialtyAbbreviation: null;
  shiftId: number | null;
  value: number;
  valueMax: null;
  statusId: number | null;
  documentIds: any[];
  reasonId: null;
  reason: null;
  dateApproved: null;
  approvedBy: null;
  approvedById: null;
  dateCreated: Date;
  createdBy: string;
  createdById: number;
  createdAt: null;
  dateLastUpdated: Date;
  lastUpdatedBy: string;
  lastUpdatedById: number;
}

export enum ReqOrderFieldNames {
  UNIT_NAME = 'UNIT_NAME',
  DISCIPLINE = 'DISCIPLINE',
  SPECIALTY = 'SPECIALTY',
  EXT_JOB_DESCRIPTION = 'EXT_JOB_DESCRIPTION',
  REGION = 'REGION',
  LICENSE = 'LICENSE',
  CERTIFICATION = 'CERTIFICATION',
  POSITIONS_AVAILABLE = 'POSITIONS_AVAILABLE',
  ORDER_TYPE = 'ORDER_TYPE',
  START_DATE = 'START_DATE',
  END_DATE = 'END_DATE',
  INTERNAL_NOTES = 'INTERNAL_NOTES',
  VIRTUAL_RATING = 'VIRTUAL_RATING',
}
export enum OrderPayPackagesAction {
  RESET = 2,
  UPDATE_MARGIN = 1,
  TARGET_MARGIN_RESET = 3,
}
export interface ITargetMarginSaveAciton {
  payload: IUpdateTargetMarginsPayload;
  componentHandle?: React.MutableRefObject<GridApiPro> | null;
}
export interface ITargetMarginGetAciton {
  payload: ITargetMarginGetQuery;
  componentHandle?: React.MutableRefObject<GridApiPro> | null;
}
export interface ITargetMarginGetQuery {
  orderId: number;
  userId: number;
}
export interface IUpdateTargetMarginsPayload {
  orderId: number;
  userId: number;
  marginTargetDetails: ITargetMarginOriginalResponse;
}
export interface IOrderPackagesInteraction {
  action: OrderPayPackagesAction | null;
}
export interface IOrderPayPackages {
  orderId: number;
  bookingPeriodId: number;
  scenarioId: number;
  facilityId: number;
  packageName: string;
  scenarioName: string;
  scenarioStatusId: number;
  scenarioStatus: string;
  bookingPeriodStartDate: Date;
  bookingPeriodEndDate: Date;
  bookingPeriodDuration: number;
  packageTimestamp: string;
  targetMarginOrderId: number;
  targetMarginSourceId: number;
  targetMarginSource: string;
  targetMarginJobStatusId: number;
  targetMarginJobStatusTypeId: number;
  targetMarginJobStatusType: string;
  targetMarginJobStatusNote: string;
  targetMarginJobStatusCreatedById: number;
  targetMarginJobStatusCreatedByDate: Date;
  targetMarginJobStatusUpdatedById: number;
  targetMarginJobStatusUpdatedByDate: Date;
  orderPayPackageStatusId: number;
  orderPayPackageStatus: string;
  orderStartDate: null;
  orderEndDate: null;
  orderDuration: null;
  startDay: number;
  startDayName: string;
  endDay: number;
  endDayName: string;
  timestamp: string;
  disciplineId: number;
  discipline: string;
  disciplineAbbr: string;
  specialtyId: number;
  specialty: string;
  specialtyAbbr: string;
  subSpecialtyId: number;
  subSpecialty: null;
  subSpecialtyAbbr: string;
  shiftId: null;
  shift: null;
  externalPayPackageId: number;
  jdhPostingStatusId: null;
  jdhPostingStatus: null;
  jdhPostingId: null;
  publishingStatus: string;
  originalTargetMargin: number;
  currentTargetMargin: number;
  weeklyGrossPay: number;
  minimumWeeklyGrossPay: number;
  maximumWeeklyGrossPay: number;
  weeklyGrossPayRaw: number;
  isDefaultCalculation: boolean;
  billRate: number;
  vms: number;
  other: number;
  payRate: number;
  lodgingPerDiem: null;
  mealPerDiem: null;
  targetMarginDefault: number;
  targetMarginDayShift: number;
  targetMarginNightShift: number;
  targetMarginDayNightShift: number;
  payRangeMinMaxPercentage: number;
  defaultWeeklyPay: number;
  grossProfit: null;
  grossMargin: null;
  revenue: null;
  negotiatedContributionMargin: null;
  orientationHours: null;
  orientationHoursWeekly: null;
  payOvertimeHours: number;
  payDoubletimeHours: number;
  payPremiumHours: number;
  billRateAdjustment: number;
  payrollTaxPercent: number;
  minimumRequiredHours: null;
  hoursPerWeek: null;
  hoursPerShift: null;
  approvedUserId: number;
  approvedUserFirst: string;
  approvedUserLast: string;
  approvedDateAt: Date;
  verifiedUserId: number;
  verifiedUserFirst: string;
  verifiedUserLast: string;
  verifiedDateAt: Date;
  notes: null;
  calculationFailureReason: null;
  isCalculationOnError: null;
  createdUserId: number;
  createdUserFirst: string;
  createdUserLast: string;
  createdDateAt: Date;
  updatedUserId: number;
  updatedUserFirst: string;
  updatedUserLast: string;
  updatedDateAt: Date;
  weeklyGrossPayPercentChange: number;
  lastKnownPositionsAvailable: number;
  updateCustomPayPackage: boolean;
  isCustom: boolean;
  stages: any[];
  scenario: any | null;
  mode: number;
}
export interface IGetResetOrderPayPackagesPayload {
  orderId: number;
  userId: number;
  refreshOrderMarginScenarioDetailsInlinePayload: IOrderPayPackagesResetValueQuery[];
}

export interface IOrderPayPackagesResetValueQuery {
  orderId: number;
  bookingPeriodId: number;
  scenarioId: number;
}

export interface IGetResetTargetMarginPayload {
  isRefreshFlow: boolean;
  targetMarginOrders: IOrderTargetMargin[];
  targetMarginOrderUpdateHistoryItems: any[];
}

// ────────────────────────────────────────────────────────────────────────────────
// Order Pay Packages (margin-inline-details API)
// ────────────────────────────────────────────────────────────────────────────────

export interface IGetOrderPayPackagesQuery {
  orderId?: number;
  facilityId?: number;
}

// ────────────────────────────────────────────────────────────────────────────────
// Placement Pay Packages (Order Profile → Pay Packages → Placement Pay Packages)
// POST placement/margin/margin-inline-details/placements - server-side pagination, sort, filter
// ────────────────────────────────────────────────────────────────────────────────

export interface IPlacementPayPackagesRequest {
  orderId?: number | null;
  candidateId?: number | null;
  facilityId?: number | null;
  orderIds?: number[];
  candidateIds?: number[];
  pageNumber: number;
  pageSize: number;
  sortColumn?: string | null;
  sortDirection?: string | null;
  isArchived?: boolean | null;
  candidateName?: string | null;
  placementStatusIds?: number[];
  payPackageStatusIds?: number[];
}

export interface IPlacementPayPackagesResponse<T = any> {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  items: T[];
}

export interface IGetPlacementPayPackagesQuery extends IPlacementPayPackagesRequest {}

export interface IPlacementPayPackageEmployee {
  employeeId: number | null;
  firstName: string | null;
  lastName: string | null;
  phoneNumber?: string | null;
  email?: string | null;
}

export interface IPlacementPayPackageDetailsValue {
  category?: string | null;
  categoryId?: number | null;
  subCategory?: string | null;
  subCategoryId?: number | null;
  pickListDescription?: string | null;
  payPackageValues?: {
    amount?: number | null;
    description?: string | null;
    receiptsRequiredToPay?: boolean | null;
  } | null;
}

export interface IPlacementPayPackageAssignment {
  payPackageDetailsValues?: IPlacementPayPackageDetailsValue[] | null;
  travel?: {
    arrivingTravel?: number | null;
    endingTravel?: number | null;
    interimTravel?: number | null;
    amnFlight?: number | null;
    amnRentalCar?: number | null;
  } | null;
}

export interface IPlacementPayPackageSplit {
  splitId: number;
  effectiveStartDate?: string | Date | null;
  effectiveEndDate?: string | Date | null;
  weeklyGrossPay?: number | null;
  shiftId?: number | null;
  shift?: string | null;
  hoursPerWeek?: number | null;
  hoursPerShift?: number | null;
  billRate?: number | null;
  vms?: number | null;
  other?: number | null;
  payRate?: number | null;
  lodgingPerDiem?: number | null;
  mealPerDiem?: number | null;
}

export interface IPlacementPayPackageScenario {
  placementId: number;
  bookingPeriodId: number;
  scenarioId: number;
  scenarioName: string;
  scenarioStatusId?: number | null;
  scenarioStatus?: string | null;
  createdUserId?: number | null;
  createdUserFirst?: string | null;
  createdUserLast?: string | null;
  createdDateAt?: string | Date | null;
  updatedUserId?: number | null;
  updatedUserFirst?: string | null;
  updatedUserLast?: string | null;
  updatedDateAt?: string | Date | null;
  approvedUserId?: number | null;
  approvedUserFirst?: string | null;
  approvedUserLast?: string | null;
  approvedDateAt?: string | Date | null;
  verifiedUserId?: number | null;
  verifiedUserFirst?: string | null;
  verifiedUserLast?: string | null;
  verifiedDateAt?: string | Date | null;
  grossMargin?: number | null;
  grossProfit?: number | null;
  revenue?: number | null;
  negotiatedContributionMargin?: number | null;
  weeklyGrossPay?: number | null;
  tla?: boolean | null;
  assignment?: IPlacementPayPackageAssignment | null;
  splits?: IPlacementPayPackageSplit[] | null;
  mode?: number | null;
}

export interface IPlacementPayPackageRow {
  orderId?: number | null;
  placementId: number;
  placementStartDate?: string | Date | null;
  placementEndDate?: string | Date | null;
  placementDuration?: number | null;
  placementStatusId?: number | null;
  placementStatus?: string | null;
  archived?: boolean | null;

  travelerId?: number | null;
  brandId?: number | null;
  brand?: string | null;
  candidateNameFirst?: string | null;
  candidateNameMiddle?: string | null;
  candidateNameLast?: string | null;
  candidateNameGoesBy?: string | null;

  disciplineId?: number | null;
  discipline?: string | null;
  specialtyId?: number | null;
  specialty?: string | null;
  subSpecialtyId?: number | null;
  subSpecialty?: string | null;
  disciplineAbbr?: string | null;
  specialtyAbbr?: string | null;
  subSpecialtyAbbr?: string | null;

  originalDisciplineId?: number | null;
  originalSpecialtyId?: number | null;
  originalSubSpecialtyId?: number | null;

  bookingPeriodId: number;
  bookingPeriodStartDate?: string | Date | null;
  bookingPeriodEndDate?: string | Date | null;
  bookingPeriodDuration?: number | null;
  packageName?: string | null;

  // Scenario
  scenarioId: number;
  scenarioName?: string | null;
  scenarioStatus?: string | null;
  scenarioStatusId?: number | null;
  grossMargin?: number | null;
  grossProfit?: number | null;
  negotiatedContributionMargin?: number | null;
  weeklyGrossPay?: number | null;
  createdUserFirst?: string | null;
  createdUserLast?: string | null;
  createdDateAt?: string | Date | null;
  approvedUserFirst?: string | null;
  approvedUserLast?: string | null;
  approvedDateAt?: string | Date | null;
  verifiedUserFirst?: string | null;
  verifiedUserLast?: string | null;
  verifiedDateAt?: string | Date | null;
  updatedUserFirst?: string | null;
  updatedUserLast?: string | null;
  updatedDateAt?: string | Date | null;
  tla?: boolean | null;
  mode?: number | null;

  // Split row
  splitId?: number | null;
  splitStartDate?: string | Date | null;
  splitEndDate?: string | Date | null;
  weeklyGrossPaySplit?: number | null;
  billRate?: number | null;
  vms?: number | null;
  other?: number | null;
  payRate?: number | null;
  shift?: string | null;
  hoursPerWeek?: number | null;
  hoursPerShift?: number | null;
  lodgingPerDiem?: number | null;
  mealPerDiem?: number | null;

  // Derived for grid display
  candidateName?: string;
  skillSet?: string;
  placementSkillSet?: string;
  createdByName?: string;
  approvedByName?: string;
  verifiedByName?: string;
  updatedByName?: string;
  numberOfSplits?: number;
  totalBonuses?: number;
  totalReimbursements?: number;
}
